// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import VueScroll from 'vuescroll';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ImageRatio } from '../../_contracts';
import { prepareImage } from '../../_filters';
import { ReadMoreLink } from '../ReadMoreLink';
import { ThumbnailsListItem } from '../ThumbnailsListItem/ThumbnailsListItem';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let ThumbnailsList = class ThumbnailsList extends Vue {
    resolveArticleImages() {
        this.articles.map((article) => {
            article.thumbnail = this.getThumbnail(article);
        });
    }
    /**
     * Converts articles to MergedListItem format for ThumbnailsListItem
     */
    get articleItems() {
        return this.articles.map((article, index) => ({
            type: 'article',
            component: '',
            data: article,
            props: {},
            position: index,
            key: `article-${article.id || index}`
        }));
    }
    /**
     * Resolves the applicable `Image` for the current screen resolution.
     */
    getThumbnail(article) {
        if (typeof article.properties.cover !== 'object' || typeof article.properties.cover === null ||
            typeof article.properties.cover.image !== 'object' || article.properties.cover.image === null) {
            return {
                src: '',
                width: null,
                height: null
            };
        }
        return prepareImage(article.properties.cover.image, ImageRatio.Standard169, 90, this.isLazy);
    }
};
__decorate([
    Prop({
        type: Array,
        required: true
    })
], ThumbnailsList.prototype, "articles", void 0);
__decorate([
    Prop({
        type: String,
        required: false,
        default: ''
    })
], ThumbnailsList.prototype, "fallbackImage", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: true
    })
], ThumbnailsList.prototype, "isLazy", void 0);
__decorate([
    Prop({
        type: Object,
        required: false
    })
], ThumbnailsList.prototype, "readMoreLink", void 0);
__decorate([
    Prop({
        type: Object,
        required: true
    })
], ThumbnailsList.prototype, "windowService", void 0);
__decorate([
    Prop({
        type: Object,
        required: false,
        default: () => {
            return { showArticleTags: false };
        }
    })
], ThumbnailsList.prototype, "listConfig", void 0);
__decorate([
    Watch('articles', { immediate: true })
], ThumbnailsList.prototype, "resolveArticleImages", null);
ThumbnailsList = __decorate([
    Component({
        name: 'ThumbnailsList',
        components: {
            ReadMoreLink,
            ThumbnailsListItem,
            VueScroll
        },
        template: `
    <div class="thumbnails-list">
      <div class="thumbnails-list__container" :class="{ '--with-read-more' : readMoreLink }">
        <!-- Articles list -->
        <ul v-if="articleItems && articleItems.length" class="list-unstyled">
          <template v-for="item in articleItems">
            <ThumbnailsListItem
              v-if="item.type === 'article'"
              :key="item.key"
              :item="item"
              :list-config="listConfig" />
          </template>
        </ul>
        <!-- END | Articles list -->
      </div>

      <!-- "Read more" button -->
      <div v-if="readMoreLink" class="thumbnails-list__read-more-link">
        <ReadMoreLink :link="readMoreLink" />
      </div>
    </div>
  `
    })
], ThumbnailsList);
export { ThumbnailsList };
